// Utils
import { PRICE_FACTOR } from "src/utils/formatters";

// Components
import {
    NumberInput,
    type NumberInputProps,
} from "src/components/generics/numberInput/NumberInput";

export function DomainAmountInput({ value, onChange, ...props }: NumberInputProps): JSX.Element {
    return (
        <NumberInput
            value={value / PRICE_FACTOR}
            onChange={(val) => onChange(val && Math.round(val * PRICE_FACTOR))}
            {...props}
        />
    );
}
